// extracted by mini-css-extract-plugin
export default {"globalSearchResults":"styles_globalSearchResults__apiiP","subtitle":"styles_subtitle__Lf67n"};